import { Maybe } from '@csp/csp-common-model';
import { useLocation } from 'react-router-dom';
import { useAuthContext } from '../../auth/context/hook/useAuthContext';
import { useIsUnauthenticatedRoute } from './useIsUnauthenticatedRoute';

export const useInitialRedirectToValue = (): Maybe<string> => {
  const location = useLocation();
  const isUnauthenticatedRoute = useIsUnauthenticatedRoute();
  const { isAuthenticated } = useAuthContext();

  // Next in prio is path, but only if the route is not an unauthenticated route
  if (!isUnauthenticatedRoute && !isAuthenticated) {
    return location.pathname;
  }
  return undefined;
};
